// extracted by mini-css-extract-plugin
export default {"container":"style_container__4mj2L","content":"style_content__dEQ29"};